<script lang="ts">
  import { getContext } from "svelte"
  import ModuleTypes from "../constants/ModuleTypes"
  import IntegrationTypes from "../constants/IntegrationTypes"
  import buildModuleUrl from "../lib/buildModuleUrl"
  import { buildUrlData } from "../lib/buildModuleUrlData"
  import ModuleContainer from "../components/ModuleContainer.svelte"
  import { getFlowTypeFromModuleType } from "../lib/Helpers"
  import type { Settings } from "website_script/types/settings"
  import type { Environment } from "website_script/types/environment"
  import type { ElementData } from "website_script/lib/Parsers"

  const settings = getContext<Settings>("settings")
  const { abTesting, trackFunction } = getContext<Environment>("environment")

  export let elementData: ElementData
  export let moduleType: ModuleTypes

  // Should be a switches if it grows
  const integrationType =
    moduleType === ModuleTypes.TRADE_IN
      ? IntegrationTypes.TRADE_IN_INLINE_FORM
      : IntegrationTypes.TEST_DRIVE_INLINE_FORM

  const urlBuildData = buildUrlData({
    settings,
    moduleType,
    integrationType,
    abTesting: $abTesting,
    departmentUuid: elementData.departmentId,
    elData: elementData,
  })

  $: url = buildModuleUrl(urlBuildData)

  trackFunction({
    entity: "inline-form",
    element: moduleType,
    action: "displayed",
    type: "displayed_cta",
    flow: getFlowTypeFromModuleType(moduleType) ?? undefined,
  })

  const scrollToTop = () => {
    // Scroll to the top of the form
    // TODO: implement
  }
</script>

<!--
@component

Takes a module type, that is in this case a kind of form.
This should be either ModuleTypes.TRADE_IN or ModuleTypes.BOOK_TEST_DRIVE.

It is then loaded in an inline iframe.
-->
<ModuleContainer
  {moduleType}
  {url}
  moduleData={urlBuildData}
  locale={settings.locale}
  displayInline
  on:viewChanged={scrollToTop}
  on:flowEvent
/>
